/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toast_Expense_Sync_Confirm_SuccessInputs */

const vi_toast_expense_sync_confirm_success = /** @type {(inputs: Toast_Expense_Sync_Confirm_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã tạo khoản chi từ giao dịch`)
};

/**

* @param {Toast_Expense_Sync_Confirm_SuccessInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const toast_expense_sync_confirm_success = /** @type {((inputs?: Toast_Expense_Sync_Confirm_SuccessInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toast_Expense_Sync_Confirm_SuccessInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_toast_expense_sync_confirm_success(inputs)
});